export const PRODUCT_RATING_CONTAINER = 'js-product-rating-container';
export const PRODUCT_RATING_COUNT = 'js-product-rating-count';
export const PRODUCT_RATING_STARS = 'js-product-rating-stars';

export const ABOVE_THE_FOLD_RATING_CONTAINER = 'js-above-the-fold-rating-container';

export const REVIEWS_SECTION_ID = 'product-reviews';

export const REVIEWS_SECTION_LIST = 'product-reviews-list';
